<template>
  <div>
    <div class="main-header-left d-none d-lg-block">
      <div class="logo-wrapper">
        <router-link to="/" v-if="sidebar == 'compact'">
          <img :src="mainHeaderLogoImageUrl" alt />
        </router-link>
        <router-link to="/" v-else>
          <img :src="mainHeaderLogoImageUrl" alt />
        </router-link>
      </div>
    </div>
    <div class="sidebar custom-scrollbar">
      <div class="sidebar-user text-center">
        <div>
          <img class="img-100 rounded-circle" :src="avatarImageUrl" alt="#" />
          <div class="profile-edit">
            <router-link to="/users/edit">
              <vue-feather type="edit"></vue-feather>
            </router-link>
          </div>
        </div>
        <h6 class="mt-3 f-14">{{ currentUsername }}</h6>
        <p>{{ currentRoleName }}</p>
      </div>
      <ul class="sidebar-menu" id="myDIV"
        :style="[layout.settings.sidebar.type == 'horizontal_sidebar' ? layout.settings.layout_type == 'rtl' ? { 'margin-right': margin + 'px' } : { 'margin-left': margin + 'px' } : { margin: '0px' }]">
        <li class="left-arrow"
          :class="{ 'd-none': layout.settings.layout_type == 'rtl' ? hideLeftArrowRTL : hideLeftArrow }"
          @click="(layout.settings.sidebar.type === 'horizontal_sidebar' && layout.settings.layout_type === 'rtl') ? scrollToLeftRTL() : scrollToLeft()">
          <i class="fa fa-angle-left"></i>
        </li>

        <li v-for="(menuItem, index) in menuItems" :key="index" :class="{ 'active': menuItem.active }">
          <!-- Sub -->
          <a href="javascript:void(0)" class="sidebar-header" v-if="menuItem.type == 'sub'"
            @click="setNavActive(menuItem, index)">
            <vue-feather :type="menuItem.icon" class="top"></vue-feather>
            <span>
              {{ $t(menuItem.title) }}
              <span :class="'badge badge-pill rounded-pill badge-' + menuItem.badgeType" v-if="menuItem.badgeType">{{
                menuItem.badgeValue }}</span>
            </span>
            <i class="fa fa-angle-right pull-right" v-if="menuItem.children"></i>
          </a>
          <!-- Link -->
          <router-link :to="menuItem.path" class="sidebar-header" v-if="menuItem.type == 'link'" router-link-exact-active>
            <vue-feather :type="menuItem.icon" class="top"></vue-feather>
            <span>
              {{ $t(menuItem.title) }}
              <span :class="'badge badge-' + menuItem.badgeType + ' ms-3'" v-if="menuItem.badgeType">{{
                menuItem.badgeValue }}</span>
            </span>
            <i class="fa fa-angle-right pull-right" v-if="menuItem.children"></i>
          </router-link>
          <!-- External Link -->
          <a :href="menuItem.path" class="sidebar-header" v-if="menuItem.type == 'extLink'"
            @click="setNavActive(menuItem, index)">
            <vue-feather :type="menuItem.icon" class="top"></vue-feather>
            <span>
              {{ $t(menuItem.title) }}
              <span :class="'badge badge-' + menuItem.badgeType + ' ms-3'" v-if="menuItem.badgeType">{{
                menuItem.badgeValue }}</span>
            </span>
            <i class="fa fa-angle-right pull-right" v-if="menuItem.children"></i>
          </a>
          <!-- External Tab Link -->
          <a :href="menuItem.path" target="_blank" class="sidebar-header" v-if="menuItem.type == 'extTabLink'"
            @click="setNavActive(menuItem, index)">
            <vue-feather :type="menuItem.icon" class="top"></vue-feather>
            <span>
              {{ $t(menuItem.title) }}
              <span :class="'badge badge-' + menuItem.badgeType + ' ms-3'" v-if="menuItem.badgeType">{{
                menuItem.badgeValue }}</span>
            </span>
            <i class="fa fa-angle-right pull-right" v-if="menuItem.children"></i>
          </a>
          <!-- 2nd Level Menu -->
          <ul class="sidebar-submenu" v-if="menuItem.children">
            <li v-for="(childrenItem, index) in menuItem.children" :key="index"
              :class="{ 'active': childrenItem.active }">
              <!-- Sub -->
              <a href="javascript:void(0)" v-if="childrenItem.type == 'sub'" @click="setNavActive(childrenItem, index)">
                <i class="fa fa-circle"></i>
                {{ $t(childrenItem.title) }}
                <span :class="'badge badge-' + childrenItem.badgeType + ' pull-right'" v-if="childrenItem.badgeType">{{
                  childrenItem.badgeValue }}</span>
                <i class="fa fa-angle-right pull-right" v-if="childrenItem.children"></i>
              </a>
              <!-- Link -->
              <router-link :to="childrenItem.path" v-if="childrenItem.type == 'link'" router-link-exact-active>
                <i class="fa fa-circle"></i>
                {{ $t(childrenItem.title) }}
                <span :class="'badge badge-' + childrenItem.badgeType + ' pull-right'" v-if="childrenItem.badgeType">{{
                  childrenItem.badgeValue }}</span>
                <i class="fa fa-angle-right pull-right" v-if="childrenItem.children"></i>
              </router-link>
              <!-- External Link -->
              <a :href="childrenItem.path" v-if="childrenItem.type == 'extLink'">
                <i class="fa fa-circle"></i>
                {{ $t(childrenItem.title) }}
                <span :class="'badge badge-' + childrenItem.badgeType + ' pull-right'" v-if="childrenItem.badgeType">{{
                  childrenItem.badgeValue }}</span>
                <i class="fa fa-angle-right pull-right" v-if="childrenItem.children"></i>
              </a>
              <!-- External Tab Link -->
              <a :href="childrenItem.path" target="_blank" v-if="childrenItem.type == 'extTabLink'">
                <i class="fa fa-circle"></i>
                {{ $t(childrenItem.title) }}
                <span :class="'badge badge-' + childrenItem.badgeType + ' pull-right'" v-if="childrenItem.badgeType">{{
                  childrenItem.badgeValue }}</span>
                <i class="fa fa-angle-right pull-right" v-if="childrenItem.children"></i>
              </a>
              <!-- 3rd Level Menu -->
              <ul class="sidebar-submenu horizontal-child-sub" v-if="childrenItem.children">
                <li v-for="(childrenSubItem, index) in childrenItem.children" :key="index">
                  <!-- Link -->
                  <router-link :to="childrenSubItem.path" v-if="childrenSubItem.type == 'link'" router-link-exact-active>
                    <i class="fa fa-circle"></i>
                    {{ $t(childrenSubItem.title) }}
                    <span :class="'badge badge-' + childrenSubItem.badgeType + ' pull-right'"
                      v-if="childrenSubItem.badgeType">{{ childrenSubItem.badgeValue }}</span>
                    <i class="fa fa-angle-right pull-right" v-if="childrenSubItem.children"></i>
                  </router-link>
                  <!-- External Link -->
                  <a :href="childrenSubItem.path" v-if="childrenSubItem.type == 'extLink'">
                    <i class="fa fa-circle"></i>
                    {{ $t(childrenSubItem.title) }}
                    <span :class="'badge badge-' + childrenSubItem.badgeType + ' pull-right'"
                      v-if="childrenSubItem.badgeType">{{ childrenSubItem.badgeValue }}</span>
                    <i class="fa fa-angle-right pull-right" v-if="childrenSubItem.children"></i>
                  </a>
                  <!-- External Tab Link -->
                  <a :href="childrenSubItem.path" target="_blank" v-if="childrenSubItem.type == 'extTabLink'">
                    <i class="fa fa-circle"></i>
                    {{ $t(childrenSubItem.title) }}
                    <span :class="'badge badge-' + childrenSubItem.badgeType + ' pull-right'"
                      v-if="childrenSubItem.badgeType">{{ childrenSubItem.badgeValue }}</span>
                    <i class="fa fa-angle-right pull-right" v-if="childrenSubItem.children"></i>
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </li>
        <li class="right-arrow"
          :class="{ 'd-none': layout.settings.layout_type == 'rtl' ? hideRightArrowRTL : hideRightArrow }"
          @click="(layout.settings.sidebar.type == 'horizontal_sidebar' && layout.settings.layout_type == 'rtl') ? scrollToRightRTL() : scrollToRight()">
          <i class="fa fa-angle-right"></i>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { useI18n } from 'vue-i18n';
import { mapState, mapGetters } from "vuex";
import { clearStoredUserProfile, getCurrentUsername, getStoredAvatarUrl, hydrateStoredUserProfile, parseJwt, resolveAvatarUrl } from "../utils/auth";
import { API_BASE } from "../config/api";
const DEFAULT_AVATAR = require('../assets/images/dashboard/user.png');
const DEFAULT_MAIN_LOGO = require('../assets/images/endless-logo.png');
export default {
  name: "SidebarPage",
  setup() {
    const { t } = useI18n();
    return {
      t,
    };
  },
  data() {
    return {
      width: 0,
      height: 0,
      margin: 0,
      hideRightArrowRTL: true,
      hideLeftArrowRTL: true,
      hideRightArrow: true,
      hideLeftArrow: true,
      menuWidth: 0,
      menuMeasureTimer: null,
      avatarUrl: getStoredAvatarUrl(),
      mainHeaderLogoUrl: '',

    };
  },
  computed: {
    ...mapState({
      layout: state => state.layout.layout,
      sidebar: state => state.layout.sidebarType
    }),
    ...mapGetters({
      menuItems: 'menu/filteredMenu',
    }),
    currentUsername() {
      return getCurrentUsername() || 'Guest';
    },
    currentRoleName() {
      const payload = parseJwt(localStorage.getItem('token') || '');
      return payload.role
        || payload.roles?.[0]
        || payload['http://schemas.microsoft.com/ws/2008/06/identity/claims/role']
        || '—';
    },
    avatarImageUrl() {
      return resolveAvatarUrl(this.avatarUrl, API_BASE) || DEFAULT_AVATAR;
    },
    mainHeaderLogoImageUrl() {
      if (!this.mainHeaderLogoUrl) {
        return DEFAULT_MAIN_LOGO;
      }

      if (this.mainHeaderLogoUrl.startsWith('http')) {
        return this.mainHeaderLogoUrl;
      }

      return `${API_BASE}${this.mainHeaderLogoUrl}`;
    },

  },
  created() {

    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    if (this.width < 991) {
      this.layout.settings.sidebar.type = "default";
    }
    const val = this.sidebar
    if (val == 'default') {
      this.layout.settings.sidebar.type = 'default';
      this.layout.settings.sidebar.body_type = 'default';
    } else if (val == 'compact') {
      this.layout.settings.sidebar.type = 'compact-wrapper';
      this.layout.settings.sidebar.body_type = 'sidebar-icon';
    } else if (val == 'compact-icon') {
      this.layout.settings.sidebar.type = 'compact-page';
      this.layout.settings.sidebar.body_type = 'sidebar-hover';
    } else if (val == 'horizontal') {
      this.layout.settings.sidebar.type = 'horizontal_sidebar';
      this.layout.settings.sidebar.body_type = '';
    }
  },
  unmounted() {
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener('user-profile-updated', this.syncAvatarFromStorage);
    window.removeEventListener('system-logo-updated', this.syncMainHeaderLogo);
    if (this.menuMeasureTimer) {
      clearTimeout(this.menuMeasureTimer);
      this.menuMeasureTimer = null;
    }
  },
  mounted() {
    this.$store.dispatch('auth/loadPermissions');
    window.addEventListener('user-profile-updated', this.syncAvatarFromStorage);
    window.addEventListener('system-logo-updated', this.syncMainHeaderLogo);
    this.$nextTick(() => {
      this.scheduleMenuMeasure();
    });
    this.syncAvatarFromStorage();
    this.syncMainHeaderLogo();
    this.menuItems.filter(items => {
      if (items.path === this.$route.path)
        this.$store.dispatch("menu/setActiveRoute", items);
      if (!items.children) return false;
      items.children.filter(subItems => {
        if (subItems.path === this.$route.path)
          this.$store.dispatch("menu/setActiveRoute", subItems);
        if (!subItems.children) return false;
        subItems.children.filter(subSubItems => {
          if (subSubItems.path === this.$route.path)
            this.$store.dispatch("menu/setActiveRoute", subSubItems);
        });
      });
    });
  },
  methods: {
    async syncAvatarFromStorage() {
      await hydrateStoredUserProfile(API_BASE);
      this.avatarUrl = getStoredAvatarUrl();
    },
    async syncMainHeaderLogo() {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          this.mainHeaderLogoUrl = '';
          return;
        }

        const response = await fetch(`${API_BASE}/api/System/main-header-logo`, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          return;
        }

        const data = await response.json();
        this.mainHeaderLogoUrl = data.logoUrl || '';
      } catch {
        // Keep default logo when settings endpoint is unavailable.
      }
    },
    scheduleMenuMeasure() {
      if (this.menuMeasureTimer) {
        clearTimeout(this.menuMeasureTimer);
      }

      this.menuMeasureTimer = setTimeout(() => {
        const elmnt = document.getElementById("myDIV");
        if (!elmnt) {
          this.menuWidth = 0;
          this.hideRightArrow = true;
          this.hideLeftArrowRTL = true;
          return;
        }

        this.menuWidth = elmnt.offsetWidth;
        if (this.menuWidth > window.innerWidth) {
          this.hideRightArrow = false;
          this.hideLeftArrowRTL = false;
        } else {
          this.hideRightArrow = true;
          this.hideLeftArrowRTL = true;
        }
      }, 150);
    },
    setNavActive(item) {
      this.$store.dispatch("menu/setNavActive", item);
    },
    handleResize() {
      this.width = window.innerWidth - 310;
      this.scheduleMenuMeasure();
    },
    scrollToRightRTL() {
      this.temp = this.width + this.margin;
      // Checking condition for remaing margin
      if (this.temp === 0) {
        this.margin = this.temp;
        this.hideRightArrowRTL = true;
      }
      // else
      else {
        this.margin += this.width;
        this.hideRightArrowRTL = false;
        this.hideLeftArrowRTL = false;
      }
    },
    scrollToLeftRTL() {
      // If Margin is reach between screen resolution
      if (this.margin <= -this.width) {
        this.margin += -this.width;
        this.hideLeftArrowRTL = true;
      }
      //Else
      else {
        this.margin += -this.width;
        this.hideRightArrowRTL = false;
      }
    },
    scrollToLeft() {
      // If Margin is reach between screen resolution
      if (this.margin >= -this.width) {
        this.margin = 0;
        this.hideLeftArrow = true;
      }
      //Else
      else {
        this.margin += this.width;
        this.hideRightArrow = false;
      }
    },
    scrollToRight() {
      this.temp = this.menuWidth + this.margin;
      // Checking condition for remaing margin
      if (this.temp < this.menuWidth) {
        this.margin = -this.temp;
        this.hideRightArrow = true;
      }
      // else
      else {
        this.margin += -this.width;
        this.hideLeftArrow = false;
      }
    },
    logout() {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('Userinfo');
      clearStoredUserProfile();
      this.$router.replace('/auth/login');
    }
  }
};
</script>
